const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:4345" : "");

const isDev = process.env.NODE_ENV === "development";
const log = (...a) => isDev && console.log(...a);
const warn = (...a) => isDev && console.warn(...a);
const err = (...a) => console.error(...a);

const isAskResponseValid = (data) => {
  const ask = data?.ask || data;
  return !!(
    ask?.answer ||
    ask?.baani_text ||
    ask?.baani_audio_base64 ||
    ask?.original_text ||
    ask?.sarvam_text ||
    ask?.bhashini_text ||
    ask?.text ||
    ask?.message ||
    ask?.response ||
    ask?.sarvam_audio_base64 ||
    ask?.bhashini_audio_base64 ||
    ask?.audio_base64
  );
};

export const callWeatherApiBackend = async (data, maxRetries = 3, delayMs = 1000, timeoutMs = 60000) => {
  const url = `${API_BASE_URL}/api/weather/weather-api`;
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    const ctrl = new AbortController();
    const id = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
      log(`weatherApi fetch: attempt ${attempt}/${maxRetries} → ${url}`);
      const res = await fetch(url, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        signal: ctrl.signal 
      });
      clearTimeout(id);
      
      if (!res.ok) {
        warn(`weatherApi: HTTP ${res.status} on attempt ${attempt}`);
        if (attempt < maxRetries) {
          await new Promise((r) => setTimeout(r, delayMs));
          continue;
        }
        return null;
      }
      
      const responseData = await res.json().catch(() => null);
      if (!responseData || !isAskResponseValid(responseData)) {
        warn(`weatherApi: invalid response on attempt ${attempt}`, responseData);
        if (attempt < maxRetries) {
          await new Promise((r) => setTimeout(r, delayMs));
          continue;
        }
        return null;
      }
      return responseData;
    } catch (e) {
      clearTimeout(id);
      warn(`weatherApi: ${e.name === "AbortError" ? "timeout" : "error"} on attempt ${attempt}`, e);
      if (attempt < maxRetries) {
        await new Promise((r) => setTimeout(r, delayMs));
        continue;
      }
    }
  }
  err(`weatherApi: all ${maxRetries} attempts failed for ${url}`);
  return null;
};
